import { Typography } from 'antd'
import styled from 'styled-components'

const StyledDisplayName = styled(Typography.Title)`
  font-size: 14px !important;
  line-height: 22px !important;
`

export { StyledDisplayName }
